export const selectAuthState = (state) => ({
  userId: state.auth.userId,
  token: state.auth.token,
  mantisBusiness: state.auth.mantisBusiness,
  user: state.auth.user
});
